import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../store";
import { fetchReferralStatus } from "../../store/slices/referral";
const ReferralRunner = () => {
    const dispatch = useDispatch();
    const { isLoaded } = useSelector((store) => store.referral);
    useEffect(() => {
        if (!isLoaded) {
            dispatch(fetchReferralStatus());
        }
    }, []);
    return _jsx(React.Fragment, {});
};
export default ReferralRunner;
